import { Venue } from './venue'
import { Asset } from './asset'
import { Organisation } from './organisation'
import { Person } from './person'
import { EventFormat } from './event-format'
import { EventTag } from './event-tag'
import { DateTimeRange, DateTimeRangeProps } from './date-time-range'
import { festivalResource } from './festival-resource'
import { last } from 'lodash'

export interface EventProps {
  id: string
  name: string
  image?: Asset
  venue?: Venue
  date?: string
  startTime?: string
  durationInMinutes?: number
  description?: string
  organisers: Organisation[]
  speakers: Person[]
  format?: EventFormat
  tags: EventTag[]
}

export class Event implements EventProps {
  private static resource = festivalResource(
    '/event',
    Event,
    e => '/event/' + e.id,
  )

  public static search = Event.resource.createList<{
    tags: string[]
    text: string
    page?: number
  }>('/search')

  public static list = Event.resource.createList()

  public static get = Event.resource.createGet<{
    id: string
  }>('/:id')

  public static getRelated = Event.resource.createList<{
    id: string
  }>('/:id/related')

  public static listHomepage = Event.resource.createList('/homepage')

  public id!: string
  public name!: string
  public slug!: string
  public image?: Asset
  public venue?: Venue
  public date?: string
  public startTime?: string
  public durationInMinutes?: number
  public description?: string
  public organisers: Organisation[]
  public speakers!: Person[]
  public format?: EventFormat
  public tags!: EventTag[]

  public festival = '2019'

  public constructor(props?: EventProps) {
    Object.assign(this, props)
  }

  public static getPagePath(props: { slug: string; festival: string }) {
    return '/festival/2019/programme/' + props.slug
  }

  public get speakerNames() {
    return this.speakers.map(s => s.name)
  }

  public get speakersDescription() {
    const { speakerNames } = this

    if (speakerNames.length <= 1) {
      return speakerNames[0]
    }

    return (
      speakerNames.slice(0, speakerNames.length - 1).join(', ') +
      ' and ' +
      last(speakerNames)
    )
  }

  public get shortDescription() {
    let desc = this.formatName + ' at The World Transformed 2019'

    if (this.speakers.length > 0) {
      return desc + ' with ' + this.speakersDescription
    }
  }

  public get imageUrl() {
    return this.image && this.image.imageUrl
  }

  public get venueName() {
    return this.venue && this.venue.name
  }

  public get formatName() {
    return (this.format && this.format.name) || 'Session'
  }

  public get timings() {
    return (
      this.date &&
      this.startTime &&
      new DateTimeRange(this as DateTimeRangeProps)
    )
  }
}
